// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/'
import FastClick from 'fastclick'

//element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

//全局自定义的css
import 'styles/index.scss'; // 全局自定义的css样式


import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.use(ElementUI);

const whiteList = ['/login', '/logout', '/account', '/404'];// 不重定向 免登陆白名单

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    //next({ path: '/' });
    next()
  }else {
    if(store.getters.hasRole){//已经拿到了用户信息，可以进入系统
      if(to.path=='/account'){
        next({name:'Operate'})
      }else if(whiteList.indexOf(to.path)!==-1 || (to.permission &&  to.permission.indexOf(store.getters.promotorType*10+store.getters.accountState)>-1) || !to.permission){
        next()
      }else{
        next({ path: '/404', query: { noGoBack: true } });
      }
    }else{
      store.dispatch('GetInfo').then(res => { // 拉取user_info
        // const hasRole = res.data.hasRole;
        return store.dispatch('GenerateRoutes', { promotorType:res.data.promotorType, accountState:res.data.accountState })
      }).then(() => { // 生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          if(!store.getters.hasRole && to.path!='/account'){
            next({name:"Account"})
          }else if(to.path==='/account' && store.getters.hasRole){
            next({name:'Operate'})
          }else if(!store.getters.hasRole && to.path==='/account'){
            next()
          }else{
            next(to)
          }
      }).catch(err => {
        //console.log(err);
      });
    }
  }
});


router.afterEach(() => {
});

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/Vue.js